import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export default function useQueryParams(defaultQueryParams: any = {}) {
    const searchParams = useSearchParams();
    const [queryParams, setQueryParams] = useState<Record<string, string>>(defaultQueryParams);

    useEffect(() => {
        const params: Record<string, string> = {};
        searchParams.forEach((value, key) => {
            params[key] = value;
        });
        setQueryParams(params);
    }, [searchParams]);

    return [queryParams];
}
